/** Raised character limit for chat surfaces where users paste long, externally-drafted prompts (agent builder, instance AI). */
export const EXTENDED_PROMPT_MAX_LENGTH = 25_000;
